export default {
  //   computed: {
  //     $momentTime() {
  //       return {
  //         second: new Date(),
  //         minute: new Date(),
  //         hour: new Date(),
  //         date: new Date(),
  //       };
  //     },
  //   }
  data() {
    return {
      momentTime: {
        second: null,
        minute: null,
        hour: null,
        date: null
      }
    };
  },
  created() {
    //@ToDo- Not sure what this was used for before, Commenting out for now and removal later
    //looks like a clock
    //setInterval(() => (this.momentTime.second = new Date()), 1000);
    //setInterval(() => (this.momentTime.minute = new Date()), 1000 * 60);
    //setInterval(() => (this.momentTime.hour = new Date()), 1000 * 60 * 60);
    //setInterval(() => (this.momentTime.date = new Date()), 1000);
  }
};
